import {
    SkyNetObjectConfigParams,
} from './SkyNetObjectRoutes.types'

// eslint-disable-next-line import/prefer-default-export
export const prepareMasterConfig = (
    domainConfig: SkyNetObjectConfigParams<any>,
    params: Record<string, unknown> = {},
) => {
    return domainConfig.config.map((tabConfig) => {
        let columns = tabConfig.columns || domainConfig.columns
        let formViews = tabConfig.formViews || domainConfig.formViews

        if (typeof columns === 'function') {
            columns = columns(params)
        }

        if (typeof formViews === 'function') {
            formViews = formViews(params)
        }

        return {
            ...tabConfig,
            columns,
            formViews,
        }
    })
}
